import { createSlice } from "@reduxjs/toolkit";

import { fetchUsers, addUsers, updateUser } from "./usersThunks";

const usersSlice = createSlice({
  name: "users",
  initialState: {
    users: [],
    total: 0,
    loading: false,
    error: null,
    // These hold the currently active filters and sort configuration.
    // For filters, you might store an array of objects like:
    // [{ field: 'firstName', operator: 'contains', value: 'John' }]
    filters: [],
    // For sortModel, an array like:
    // [{ field: 'firstName', sort: 'asc' }]
    sortModel: [],
    currentPage: 1,
    pageSize: 20, // how many users to load per request
    hasMore: true, // whether there are more users to load
  },
  reducers: {
    setFilters(state, action) {
      //   state.filters = action.payload; - chatgpt
      // append to state.filters, not set it
      state.filters = [...state.filters, ...action.payload];
      // When filters change, reset pagination
      state.currentPage = 1;
      state.users = [];
      state.hasMore = true;
    },
    setSortModel(state, action) {
      state.sortModel = action.payload;
      // When sort changes, reset pagination
      state.currentPage = 1;
      state.users = [];
      state.hasMore = true;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchUsers.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchUsers.fulfilled, (state, action) => {
        state.loading = false;
        const { data, page } = action.payload;

        // For the first page, replace the users; for later pages, append.
        const users = data.data;
        if (page === 1) {
          state.users = users;
        } else {
          state.users = [...state.users, ...users];
        }
        state.currentPage = page;
        // If the number of users received is less than pageSize, there are no more users.
        state.hasMore = users.length === state.pageSize;
      })
      .addCase(fetchUsers.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(addUsers.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(addUsers.fulfilled, (state) => {
        state.loading = false;
        state.currentPage = 1;
        state.users = [];
        state.hasMore = true; // Force full refresh
      })
      .addCase(addUsers.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

// Export the actions to update filters and sorting from your UI components.
export const { setFilters, setSortModel } = usersSlice.actions;
export default usersSlice.reducer;
